import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Config } from 'ionic-angular';

import { GuestModel } from '../../app/models/guest-model';
import { CommentModel } from '../../app/models/comment-model';

@Injectable()
export class CommentService {
  private serverUrl : string;

  constructor(private http: Http, configuration: Config) {
    this.serverUrl = configuration.get('backendUrl');
  }

  public removeComment(comment: CommentModel) : Observable<boolean> {
    return Observable.create(observer => {
      this.http.delete(this.serverUrl+'/api/'+comment.eventCode+'/comment/'+comment.key)
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(true);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(false);
        });
    });
  }

  public addComment(eventCode: String, message: CommentModel) : Observable<boolean> {
    return Observable.create(observer => {
      this.http.post(this.serverUrl+'/api/'+eventCode+'/comment',this.adaptToRemoteComment(message))
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(true);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(false);
        });
    });
  }

  public findCommentsForEvent(eventCode : string) : Observable<CommentModel[]> {
    return Observable.create(observer => {
      this.http.get(this.serverUrl+'/api/'+eventCode+'/comments/')
        .map(res => res.json().map(comment => this.adaptFromRemoteComment(eventCode, comment)))
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(data);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(error);
        });
    });
  }

  private adaptToRemoteComment(message: CommentModel) : any {
    //console.log("adaptToRemoteComment IN",message);
    let dbMessage = {
      content: message.content,
      key: message.key,
      author: message.authorId,
      creationDate: message.creationDate
    };
    //console.log("adaptToRemoteComment OUT",dbMessage);
    return dbMessage;
	}

  private adaptFromRemoteComment(eventCode: string, message: any) : CommentModel {
    //console.log("adaptFromRemoteComment IN", message);
    let mess = new CommentModel(eventCode, message.key, message.content, message.author, message.creationDate);
    //console.log("adaptFromRemoteComment OUT", mess);
    return mess;
	}

  public visitGuestbook(eventCode: string, guest : GuestModel) : Observable<Date> {
    return Observable.create(observer => {
      this.http.put(this.serverUrl+'/api/'+eventCode+'/visitComments/'+guest.getId(), {})
        .catch(this.handleError)
        .subscribe(data => {
          observer.next(data.visitDate);
          observer.complete();
        },
        error => {
          this.handleError(error);
          observer.next(undefined);
        });
    });
  }

  private handleError(error) {
    console.error(error);
    return Observable.throw((error.status === 404 ? error.text() : error.json().error) || 'Server error while reading comments');
  }

}




// WEBPACK FOOTER //
// ./src/providers/comment-service/comment-service.ts